// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabContainer_tabs__iVdLV","tabContent":"tabContainer_tabContent__cLJqr"};